/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// Importing icon images for edit and delete actions
import edit_logo from "../../../../icons/edit.svg";
import tash_logo from "../../../../icons/trash.svg";

// Row component to display individual entry data in the table
export default function Tr({
  id, // Unique identifier for the row
  color_hex_code, // Color hex code for display
  transparency, // Transparency value for display
  stroke, // Stroke value for display
  onEdit, // Function to handle editing the entry
  onDelete, // Function to handle deleting the entry
  isAllowedToEditOrDelete, // Flag to determine if the user can edit or delete
}) {
  return (
    <>
      <tr>
        <td>{color_hex_code}</td> {/* Display color hex code */}
        <td>{transparency}</td> {/* Display transparency value */}
        <td>{stroke}</td> {/* Display stroke value */}
        <td>
          {/* Edit Action */}
          <a
            onClick={(e) => {
              // Check if user is allowed to edit
              isAllowedToEditOrDelete
                ? onEdit({
                    id,
                    color_hex_code,
                    transparency,
                    stroke,
                  }) // Call onEdit with the entry data
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permission
            }}
          >
            <img src={edit_logo} alt="Edit" /> {/* Edit icon */}
          </a>
          &nbsp; {/* Space between icons */}
          {/* Delete Action */}
          <a
            onClick={(e) => {
              // Check if user is allowed to delete
              isAllowedToEditOrDelete
                ? onDelete({
                    id,
                    color_hex_code,
                    transparency,
                    stroke,
                    delete: true, // Indicate delete action
                  }) // Call onDelete with the entry data
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permission
            }}
          >
            <img src={tash_logo} alt="Delete" /> {/* Delete icon */}
          </a>
          &nbsp; {/* Space between icons */}
        </td>
      </tr>
    </>
  );
}
